import { environment } from '@environment';

export const autoApi = {
  auto_detail: `${environment.api.services}/api/travel-proxy-ms/vehicle/details`,
  auto_filter: `${environment.api.services}/api/travel-proxy-ms/vehicle/filter`,
  auto_search: `${environment.api.services}/api/travel-proxy-ms/vehicle/search`,
  auto_results: `${environment.api.services}/api/travel-proxy-ms/vehicle/results`,
  auto_images: `${environment.resources.base_lambda_img}/web/travel/autos/providers/{provider}.png`,
};
